import { render, staticRenderFns } from "./BuddycomCallTalkRecordDetail.vue?vue&type=template&id=607f98bb&scoped=true"
import script from "./BuddycomCallTalkRecordDetail.vue?vue&type=script&lang=js"
export * from "./BuddycomCallTalkRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./BuddycomCallTalkRecordDetail.vue?vue&type=style&index=0&id=607f98bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607f98bb",
  null
  
)

export default component.exports